// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Xm-J","label":"Radio_label__2vCNX","checkMark":"Radio_checkMark__VI19m","disabled":"Radio_disabled__27Q78"};